import { useRef } from "react";
import { Link } from "react-router";
import { useAuth } from "../context/authContext";
import useOnClickOutside from "../hooks/useOnClickOutside";
import useToggle from "../hooks/useToggle";
import SVGLogout from "../icons/Logout.svg?react";
import SVGOpenInNew from "../icons/OpenInNew.svg?react";
import SVGPerson from "../icons/Person.svg?react";
import styles from "./AccountButton.module.css";
import Icon from "./ui/Icon";
import Profile from "./ui/Profile";

const AccountButton = () => {
  const ref = useRef<HTMLDivElement>(null);
  const { user, logout } = useAuth();
  const menu = useToggle();

  useOnClickOutside(ref, menu.close);

  if (!user) {
    return null;
  }

  return (
    <div ref={ref} className={styles.wrapper}>
      <button type="button" className={styles.button} onClick={menu.toggle}>
        <Profile user={user} layout="compact" />
      </button>
      {menu.isOpen && (
        <div className={styles.menu}>
          <Profile user={user} className={styles.profile} layout="full" />
          <hr className={styles.separator} />
          <ul className={styles.list}>
            <li>
              <Link
                to="https://accounts.hgv.it"
                target="_blank"
                className={styles.menuItem}
                onClick={menu.close}
              >
                <Icon glyph={SVGPerson} className={styles.icon} />
                Konto
                <Icon glyph={SVGOpenInNew} className={styles.openInNew} />
              </Link>
            </li>
            <li>
              <button
                type="button"
                className={styles.menuItem}
                onClick={logout}
              >
                <Icon glyph={SVGLogout} className={styles.icon} />
                Abmelden
              </button>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default AccountButton;
